"use client";

import { NotificationBar } from "@litonarefin/components/NotificationBar";
import { isEmpty } from "lodash";
import { usePathname } from "next/navigation";
import {
  dateStringToMilliseconds,
  getNotificationData,
} from "@litonarefin/shared/notification/utils";

const Notification = ({ notifications, fallback = null }) => {
  const pathName = usePathname();

  const solidPathName = pathName.substring(1, pathName.length).split("/")?.[0];

  const { notification } = getNotificationData(notifications, solidPathName);

  const dealActive =
    !isEmpty(notification) &&
    dateStringToMilliseconds(notification?.notification_end_time) > new Date().getTime();

  if (dealActive) return <NotificationBar notification={notification} />;
  return fallback;
};

export default Notification;
